import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChildToParentDataService {
  constructor() { }
  private data = new BehaviorSubject(false);
  data$ = this.data.asObservable();

  changeData(data: boolean) {
    this.data.next(data)
  }
}
